<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
html, body, #app { margin: 0; background: #f6f7f9; color: #222; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }
</style>
